export default {
  "emailMarketing.title": "Email Marketing",
  "emailMarketing.column.no": "#NO",
  "emailMarketing.column.taskId": "TaskId",
  "emailMarketing.column.title": "Title",
  "emailMarketing.column.scopeTypeDesc": "PushScope",
  "emailMarketing.column.taskType": "Type",
  "emailMarketing.column.statusDesc": "Status",
  "emailMarketing.column.userNum": "UserNum",
  "emailMarketing.column.successNum": "SuccessNum",
  "emailMarketing.column.createTime": "CreateTime",
  "emailMarketing.column.pushTime": "SendTime",
  "emailMarketing.column.action": "Action",
  "emailMarketing.action.delete": "Delete",
  "emailMarketing.action.start": "StartTask",
  "emailMarketing.action.stop": "StopTask",
  "emailMarketing.action.details": "Details",
  "emailMarketing.action.edit": "Edit",
  "emailMarketing.form.taskType": "Type",
  "emailMarketing.form.taskType.once": "OnceTask",
  "emailMarketing.form.taskType.fixed": "FixedTask",
  "emailMarketing.form.template": "Template",
  "emailMarketing.form.select.placeholder": "Select",
  "emailMarketing.form.title": "Title",
  "emailMarketing.form.title.placeholder": "Enter title",
  "emailMarketing.form.pushTime": "StartTime",
  "emailMarketing.form.pushTime.placeholder": "Select time",
  "emailMarketing.form.taskCycleDays": "CycleDays",
  "emailMarketing.form.taskCycleDays.placeholder": "Enter days",
  "emailMarketing.form.pushScope": "PushScope",
  "emailMarketing.form.pushScope.recharge": "Recharge in the last few days",
  "emailMarketing.form.pushScope.designated": "Designated User",
  "emailMarketing.form.scopeTimeType": "ScopeTimeType",
  "emailMarketing.form.scopeTimeType.scope": "Scope",
  "emailMarketing.form.scopeTimeType.lately": "Lately",
  "emailMarketing.form.scopeTime": "ScopeTime",
  "emailMarketing.form.scopeTime.start": "Start Time",
  "emailMarketing.form.scopeTime.end": "End Time",
  "emailMarketing.form.scopeTimeDays": "Scope Time Days",
  "emailMarketing.form.scopeTimeDays.placeholder": "Enter days",
  "emailMarketing.form.day": "day",
  "emailMarketing.form.usernoList": "User Numbers",
  "emailMarketing.form.usernoList.placeholder": "Please enter user numbers, comma separated",
  "emailMarketing.form.content": "Content",
  "emailMarketing.form.content.placeholder": "Enter content",
  "emailMarketing.confirm.delete.title": "Delete Email Task",
  "emailMarketing.confirm.delete.content": "Are you sure you want to delete this email task?",
  "emailMarketing.confirm.start.title": "Start Task",
  "emailMarketing.confirm.start.content": "Are you sure you want to start this task?",
  "emailMarketing.confirm.stop.title": "Stop Task",
  "emailMarketing.confirm.stop.content": "Are you sure you want to stop this task?",
  "emailMarketing.confirm.ok": "Confirm",
  "emailMarketing.confirm.cancel": "Cancel",
  "emailMarketing.add.once": "New Email",
  "emailMarketing.add.fixed": "New Fixed Email",
  "emailMarketing.type.once": "OnceTask",
  "emailMarketing.type.fixed": "FixedTask",
  "emailMarketing.modal.add.title": "Add Email Task",
  "emailMarketing.modal.details.title": "Email Task Details",
  "emailMarketing.modal.edit.title": "Edit Email Task",
  "emailMarketing.submit.error": "Submit failed",
  "emailMarketing.form.cancel": "Cancel",
  "emailMarketing.form.reset": "Reset",
  "emailMarketing.form.submit": "Submit",
  
  // Dynamic fields (pushScopeParam dynamic fields)
  "emailMarketing.field.registerTime": "Register Time",
  "emailMarketing.field.registerTime.placeholder": "Please enter register time range",
  "emailMarketing.field.usernoList": "User Numbers",
  "emailMarketing.field.usernoList.placeholder": "Please enter user numbers, comma separated",
};

